import { Address } from '../../Interfaces/Address';

export const types = {
  SHOW_MODAL: 'SHOW_MODAL',
  ADD_ADDRESS: 'ADD_ADDRESS',
  SET_DEFAULT_ADDRESS: 'SET_DEFAULT_ADDRESS',
};

export interface StateInterface {
  isLoggedIn: boolean,
  displayName?: string,
  email?: string,
  showModal: boolean;
  address:Address[],
  defaultAddress: Address,
}

interface ActionInterface {
  type: string,
  payload: any,
}
interface AddAddress{
  address: Address,
  defaultAddress: Address,
}

function toggleModal(state: any): StateInterface {
  return {
    ...state,
    showModal: !state.showModal,
  };
}

const addAddress = (state: StateInterface, { address, defaultAddress }: AddAddress) => {
  const newAddresses = [...state.address];
  const newAddress = { ...address, id: newAddresses.length + 1 };
  newAddresses.push(newAddress);
  return {
    ...state,
    address: [...newAddresses],
    defaultAddress: defaultAddress ? newAddress : state.defaultAddress,
  };
};
const setDefaultAddress = (state: StateInterface, payload: number) => {
  const addresses = [...state.address];
  const newDefaultAddress = addresses.findIndex(({ id }) => id === payload);
  return {
    ...state,
    defaultAddress: state.address[newDefaultAddress],
  };
};

export const Reducer = (state: StateInterface, action: ActionInterface) => {
  switch (action.type) {
    case types.SHOW_MODAL:
      return toggleModal(state);
    case types.ADD_ADDRESS:
      return addAddress(state, action.payload);
    case types.SET_DEFAULT_ADDRESS:
      return setDefaultAddress(state, action.payload);
    default:
      return state;
  }
};

export default Reducer;
